// The Twine context plumbing every page module writes through.

global.objectSorter = function(property) {
  return function(p1,p2) {

    var fn = property;
    if(typeof(property) == 'string') {
      fn = function(p) { return p[property].toUpperCase(); }
    }

    var val1 = fn(p1); // ignore upper and lowercase
    var val2 = fn(p2); // ignore upper and lowercase
    if (val1 < val2) {
      return -1;
    } else if (val1 > val2) {
      return 1;
    } else {
      return 0; 
    }
  }
}; 

global.refreshContext = function() {
  // One counter that means "the screen is about to be redrawn", so a binding that
  // would otherwise recompute the same thing per row can compute it once. Only the
  // live scoresheet uses it (scoresheet.feasibleLogs); the other screens never look.
  // Guarded because prematch, the report and the signature pages load context.js
  // without scoresheet.js.
  if(global.scoresheet) global.scoresheet.uiTick++;
  Twine.refresh();
};

// Never `undefined`, because Twine cannot survive it.
//
// A bound node is refreshed with `node[valueProp] = newValue`. For an input that
// is `node.value = undefined`, and the DOM turns that into the STRING
// "undefined". The next bind reads the node back out — and because the context
// value is still nullish, it writes that string into the document as if somebody
// had typed it. From then on "undefined" is a person's name and it is printed on
// the official scoresheet: "UNDEFINED U. (Undefined)".
//
// The sources are ordinary and none of them can tell they did it: a licence
// lookup whose answer carries no firstname (pre_match.js#checkLicense), a
// colleague chip missing a field. `undefined` never means the word.
//
// Measured: with a value already in the field, setting it to undefined and
// refreshing leaves node.value === "undefined", and the next bind copies that
// into the context. See test/system/undefined_never_becomes_a_name_test.rb.
global.setData = function(key, val, obj) {
  var tmp = obj || context;
  var keys = key.split(".");
  var n = keys.length;
  for(var i = 0; i < n-1; i++) {
    if(!tmp[ keys[i] ]) tmp[ keys[i] ] = {};
    tmp = tmp[ keys[i] ];
  }
  tmp[ keys[n-1] ] = val === undefined ? '' : val;

};

global.setContext = function(key, val) {
  setData(key, val);
  refreshContext();
};

global.getData = function(key, obj) {
  var tmp = obj;
  var keys = key.split(".");
  var n = keys.length;
  for(var i = 0; i < n; i++) {
    if(!tmp) return null;
    tmp = tmp[ keys[i] ];
  }
  return tmp;
};

global.getContext = function(key) {
  return getData(key, context);
};
